import axios from "axios";

// Defaults to production. For local development create a `.env.local` with:
//   REACT_APP_API_BASE_URL=http://localhost:3001/api
const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://api.appsells.biz/api";

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
});

export default axiosInstance;
